import { useQuery } from '@tanstack/react-query';
import { integrationService } from '@/services/integrationService';

/**
 * Hook para buscar todas as empresas/plataformas de integração
 */
export const useCompanies = () => {
  return useQuery({
    queryKey: ['companies'],
    queryFn: integrationService.getAllCompanies,
    refetchOnWindowFocus: false,
    refetchInterval: 60000 * 5, // 5 minutos
    staleTime: 60000 * 5, // 5 minutos
  });
};
